module.exports = "../dist/frontend/icons/benefits/green/finger.svg?5c0364474196e558329b1258fcd19b57";